import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import './WhyAven.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function WhyAven() {
  const reasons = [
    'U.S.-based advisory and representation firm',
    'Purpose-built for agent-coordinated O-1 engagements',
    'Experienced with multi-employer and project-based structures',
    'Focused on long-term credibility, not shortcuts',
  ];

  return (
    <section id="why-aven" className="why-section">
      <div className="section-container">
        <motion.div
          className="why-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="why-info">
            <h2 className="why-title">Why Work With Aven Talent Advisory</h2>

            <ul className="why-list">
              {reasons.map((reason, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                >
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>{reason}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="why-cta">
            Start with a consultation
            <ArrowRight size={18} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default WhyAven;
